import React, { useEffect, useState } from 'react';
import { default as MuiAccordion } from '@mui/material/Accordion/Accordion';
import Typography from '@mui/material/Typography/Typography';
import AccordionDetails from '@mui/material/AccordionDetails/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';
import WikiHelpTooltip from '../wiki/WikiHelpTooltip';

interface AccordionProps {
  title: string;
  padding?: boolean;
  boldTitle?: boolean;
  borders?: boolean;
  isOpen?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  tooltipId?: string;
  tooltipPlacement?: TooltipProps['placement'];
}

export default function Accordion({
  title,
  isOpen,
  children,
  disabled,
  borders = true,
  padding: isPadding = true,
  boldTitle = true,
  tooltipId,
  tooltipPlacement,
}: AccordionProps) {
  const theme = useTheme();
  const [open, setOpen] = useState(() => {
    const stored = localStorage.getItem(title.replace(/\s/g, ''));
    if (stored !== null) return stored === 'true'; // convert from string to boolean
    if (isOpen !== undefined) return isOpen;
    return false;
  });

  const handleOnOpen = (aIsOpen: boolean) => {
    localStorage.setItem(title.replace(/\s/g, ''), aIsOpen.toString());
    setOpen(aIsOpen);
  };

  const titleElement = (
    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography sx={{ fontWeight: boldTitle ? 'bold' : 'normal' }}>{title}</Typography></AccordionSummary>
  );

  const summaryTitle = tooltipId ? (
    <WikiHelpTooltip tooltipId={tooltipId} tooltipPlacement={tooltipPlacement}>
      {titleElement}
    </WikiHelpTooltip>
  ) : (
    titleElement
  );

  /*   useEffect(() => {
    if (!isOpen) return;
    setOpen(isOpen);
  }, [isOpen]); */

  return (
    <>
      <MuiAccordion
        disableGutters
        square
        disabled={disabled}
        expanded={open}
        onChange={() => handleOnOpen(!open)}
        sx={{
          background: 'transparent !important',
          boxShadow: 0,
          borderTop: borders ? `1px solid ${theme.palette.divider}` : '0',
          '&:last-child': {
            borderBottom: borders ? `1px solid ${theme.palette.divider}` : '0',
          },
          '&:before': {
            display: 'none',
          },
        }}
      >
        {summaryTitle}
        <AccordionDetails style={{ position: 'relative', padding: !isPadding ? 0 : '8px 16px 16px' }}>{children}</AccordionDetails>
      </MuiAccordion>
    </>
  );
}
